export const TIMING_ESTIMATE = 'Estimate';
export const TIMING_TOTAL_SPENT = 'Total spent time';
